import { WeaTools } from 'ecCom';
export const newUrl = '/api/cube/visual/gantt/'
export const CallAPI = (url, method, params) => {
    return new Promise((resolve, reject) => {
        WeaTools.callApi(url, method, params).then(({ noRight, ...data }) => {
            if (noRight) {
                resolve({ noRight, ...data } as any)
            } else {
                resolve(data as any)
            }
        })
    })
}


export const getGanttDatas = (params) => {
    return CallAPI(`${newUrl}getDatas`, "get", params);
}
export const save = (params) => {
    return CallAPI(`${newUrl}save`, "post", params);
}
export const deleteDatas = (params) => {
    return CallAPI(`${newUrl}deleteDatas`, "post", params);
}
export const getConditionInfo = (params) => {
    return CallAPI(`${newUrl}condition`, "get", params);
}
export const doSearchDatas = (params) => {
    return CallAPI(`${newUrl}doSearchDatas`, "get", params);
}
export const getColors = (params) => {
    return CallAPI(`${newUrl}getColors`, "get", params);
}




// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/apis/gantt.ts